import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "10",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path fill=\"#fff\" stroke=\"#000\" d=\"M.5 5C.5 2.515 2.512.5 4.995.5A4.503 4.503 0 0 1 9.5 5c0 2.484-2.016 4.5-4.505 4.5A4.5 4.5 0 0 1 .5 5Z\"></path><mask id=\"a\" fill=\"#fff\"><path d=\"M5.25 2.5H4.5v3l2.625 1.575.375-.615-2.25-1.335z\"></path></mask><path fill=\"#fff\" d=\"M5.25 2.5H4.5v3l2.625 1.575.375-.615-2.25-1.335z\"></path><path fill=\"#000\" d=\"M5.25 2.5h1v-1h-1zm-.75 0v-1h-1v1zm0 3h-1v.566l.486.291zm2.625 1.575-.514.857.85.511.518-.847zM7.5 6.46l.854.52.527-.864-.87-.516zM5.25 5.125h-1v.57l.49.29zm0-3.625H4.5v2h.75zm-1.75 1v3h2v-3zm.486 3.857L6.61 7.932 7.64 6.218 5.015 4.643zm3.993 1.239.375-.615-1.708-1.042-.375.615zM8.01 5.6 5.76 4.265l-1.02 1.72L6.99 7.32zm-1.76-.475V2.5h-2v2.625z\" mask=\"url(#a)\"></path>", 4)
  ]))]))
}
export default { render: render }